module.exports = __webpack_public_path__ + "static/media/glass-martini-alt-slash.753ce1ef.svg";